import {
  Modal,
  ModalActionButton,
  ModalActions,
  ModalCloseIconButton,
  ModalContent,
  ModalTitle,
  Typography,
} from '@ace-clublabs/shared-component-library';
import { PropsWithChildren } from 'react';

export interface TooltipModalContentProps extends PropsWithChildren {
  tooltipTitle: string;
}

export interface TooltipModalProps extends TooltipModalContentProps {
  showModal: boolean;
  closeModal: () => void;
}

export const TooltipModalSubContent = (props: { subtitle?: string; tooltipContent: string }) => {
  return (
    <>
      <ModalContent id="modal-tooltip-content">
        {props.subtitle ? <Typography variant="b1Bold">{props.subtitle}</Typography> : <></>}
        <Typography sx={{ marginBottom: '16px', whiteSpace: 'pre-line' }} className="tooltip-sub-content">
          {props.tooltipContent}
        </Typography>
      </ModalContent>
    </>
  );
};

export const TooltipModal: (props: TooltipModalProps) => JSX.Element = ({
  tooltipTitle,
  showModal,
  children,
  closeModal,
}) => {
  return (
    <Modal
      className="tooltip-modal"
      open={showModal}
      variants={{
        xs: 'bottom-sheet',
        sm: 'regular',
        md: 'regular',
        lg: 'regular',
        xl: 'regular',
      }}
      size="medium"
      aria-labelledby="remove-item"
      aria-describedby="remove-item"
      sx={{
        minHeight: '268px',
        '& .MuiDialogPaperVariant-bottom-sheet': {
          minHeight: '0 !important',
        },
      }}
    >
      <ModalTitle id="remove-modal-title" className={'qm-mask'} sx={{ paddingRight: '2.5rem', fontSize: '1.25rem' }}>
        {tooltipTitle}
        <ModalCloseIconButton
          aria-label="Close"
          onClick={() => {
            closeModal();
          }}
        />
      </ModalTitle>
      {children}
      <ModalActions
        actionLayout={{
          sm: 'fullWidth',
          md: 'fullWidth',
          lg: 'rightAlign',
          xl: 'rightAlign',
        }}
      >
        <ModalActionButton
          onClick={() => {
            closeModal();
          }}
          label="Got it"
        />
      </ModalActions>
    </Modal>
  );
};
